import Smile from '@direct-frontend/components/src/icons/illustrated/Character/CharacterWhiteSmile.svg';
import { ErrorBlank } from '../../ErrorBlank';
import { withImage } from '../../lib/hoc/withImage';

/**
 * Компонент отображения ошибок с подставленным изображением Smile
 * @kind component
 */
export const ErrorBlankSmile = withImage(ErrorBlank, {
    imageSrc: Smile,
    imageAlt: 'Ошибка',
});
